import { msg } from '@lingui/core/macro';

export interface ColumnFilterMenu {
    displayName: string;
    name: string;
    isSelected: boolean;
    submenu: ColumnFilterMenu[];
}

const TITLE_FILTER = {
    displayName: msg`Title (Rank)`,
    name: 'rank',
    isSelected: false,
    submenu: [
        {
            name: 'Master',
            displayName: msg`Master`,
            isSelected: false,
            submenu: [],
        },
        {
            name: 'Chief Officer',
            displayName: msg`Chief Officer`,
            isSelected: false,
            submenu: [],
        },
        {
            name: 'Second Officer',
            displayName: msg`Second Officer`,
            isSelected: false,
            submenu: [],
        },
    ],
};

const LOCATION_FILTER = {
    displayName: msg`Location`,
    name: 'vessel',
    isSelected: false,
    submenu: [
        {
            name: 'Location 1',
            displayName: msg`Location 1`,
            isSelected: false,
            submenu: [],
        },
        {
            name: 'Location 2',
            displayName: msg`Location 2`,
            isSelected: false,
            submenu: [],
        },
        {
            name: 'Location 3',
            displayName: msg`Location 3`,
            isSelected: false,
            submenu: [],
        },
    ],
};

const STATUS_FILTER_ASSESMENT = {
    displayName: msg`Status`,
    name: 'status',
    isSelected: false,
    submenu: [
        {
            name: 'Passed',
            displayName: msg`Passed`,
            isSelected: false,
            submenu: [],
        },
        {
            name: 'Failed',
            displayName: msg`Failed`,
            isSelected: false,
            submenu: [],
        },
        {
            name: 'Aborted',
            displayName: msg`Aborted`,
            isSelected: false,
            submenu: [],
        },
    ],
};

const STATUS_FILTER_LEARNING = {
    displayName: msg`Status`,
    name: 'status',
    isSelected: false,
    submenu: [
        {
            name: 'Passed',
            displayName: msg`Passed`,
            isSelected: false,
            submenu: [],
        },
        {
            name: 'Failed',
            displayName: msg`Failed`,
            isSelected: false,
            submenu: [],
        },
        {
            name: 'Completed',
            displayName: msg`Completed`,
            isSelected: false,
            submenu: [],
        },
    ],
};

export const MY_LEARNING_FILTERS_MENU = [TITLE_FILTER, LOCATION_FILTER, STATUS_FILTER_LEARNING];

export const MY_ASSESSMENT_FILTERS_MENU = [TITLE_FILTER, STATUS_FILTER_ASSESMENT];
